// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { Route } from "react-router-dom"
import MoreHomePage from "./MoreHomePage"
import ProfilePage from "./ProfilePage"
import PreferencesPage from "./PreferencesPage"
import GoalsPage from "./GoalsPage"
import ConstraintsPage from "./ConstraintsPage"
import MemoryPage from "./MemoryPage"
import PrivacyPage from "./PrivacyPage"

/** Nested /app/more/* route elements (T11 profile management; T15 adds Memory; 2026-08 profile batch adds Goals). */
export const moreRoutes = (
  <>
    <Route index element={<MoreHomePage />} />
    <Route path="profile" element={<ProfilePage />} />
    <Route path="preferences" element={<PreferencesPage />} />
    <Route path="goals" element={<GoalsPage />} />
    <Route path="constraints" element={<ConstraintsPage />} />
    <Route path="memory" element={<MemoryPage />} />
    <Route path="privacy" element={<PrivacyPage />} />
  </>
)
